import { Pagination, SIZE } from 'baseui/pagination';
import { Select } from 'baseui/select';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import {
  PaginationContainer,
  PaginationHighlightText,
  PaginationSectionContainer,
  PaginationText,
} from '../styles';

interface Props {
  meta: {
    currentPageSize: number;
    lastPageSize: number;
    numPages: number;
    currentPage: number;
    pageSize: number;
    itemSize: number;
  };
  setPage: (value: React.SetStateAction<number>) => void;
  setPageSize: (value: React.SetStateAction<number>) => void;
}

const overridesPagination = {
  NextButton: {
    props: {
      type: 'button',
    },
  },
  PrevButton: {
    props: {
      type: 'button',
    },
  },
  MaxLabel: {
    style: {
      fontSize: '12px',
    },
  },
  Select: {
    props: {
      overrides: {
        Popover: {
          props: {
            overrides: {
              Body: {
                style: {
                  zIndex: 100,
                },
              },
            },
          },
        },
      },
    },
  },
};

export default function TablePagination(props: Props) {
  const { t } = useTranslation();
  const { meta, setPage, setPageSize } = props;

  return (
    <PaginationContainer style={{ marginTop: 16 }}>
      <PaginationSectionContainer>
        <PaginationText>
          {`${t('common:show')} `}
          <PaginationHighlightText>
            {`${meta.currentPageSize}-${meta.lastPageSize} `}
          </PaginationHighlightText>
          {t('common:of_total_items', { total: meta.itemSize })}
        </PaginationText>
      </PaginationSectionContainer>
      <PaginationSectionContainer>
        <Pagination
          size={SIZE.mini}
          overrides={overridesPagination}
          numPages={meta.numPages}
          currentPage={meta.currentPage}
          onPageChange={({ nextPage }) => {
            setPage(nextPage - 1);
          }}
        />
      </PaginationSectionContainer>
      <PaginationSectionContainer $style={$style.itemPage}>
        <PaginationText style={{ width: 150, margin: 0 }}>
          <PaginationHighlightText>
            {t('common:item_per_page')}
          </PaginationHighlightText>
        </PaginationText>
        <Select
          options={[
            { id: 15, label: 15 },
            { id: 50, label: 50 },
            { id: 100, label: 100 },
          ]}
          value={[{ id: meta.pageSize, label: meta.pageSize }]}
          size="mini"
          onChange={(params) =>
            setPageSize((params?.option?.id as number) || 15)
          }
          clearable={false}
        />
      </PaginationSectionContainer>
    </PaginationContainer>
  );
}

const $style: { [key: string]: StyleObject | any } = {
  itemPage: {
    alignItems: 'center',
    marginTop: '16px',
    '@media screen and (min-width: 992px)': {
      marginTop: '0',
    },
  },
};
